module.exports = __webpack_public_path__ + "img/lgct-logo-long.ca1f4331.png";